import React, { useState } from "react"
import { Grid, GridColumn as Column, GridDataStateChangeEvent } from "@progress/kendo-react-grid";
import { process, SortDescriptor, State } from "@progress/kendo-data-query";
import { useNavigate, useParams } from "react-router";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWorklistPayerGroupedQuery } from "../../../../services/verifyService/verify-api";
import { WorklistRequest } from "../../../../services/verifyService/commands";
import { PayerSummaryViewCell } from "./PayerSummaryViewCell";
import { UserAssignmentSummary } from "./UserAssignmentSummary";


function PayerSummaryWorklist(){
    const {type, center,filter} = useParams();
    const {data, isLoading} = useWorklistPayerGroupedQuery(new WorklistRequest(type!, center!,filter!));
    const navigate = useNavigate();

    const initialSort:SortDescriptor[] = [{field:'payer',dir:'asc'}] ;
    const defaultGridState:State = {sort:initialSort};
    const [dataState, setDataState] = useState(defaultGridState);
    
    const createDataState = (dataState: State) => {
        return {
          dataState: dataState === undefined ? {} :dataState,};
      }; 
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setDataState(updatedState.dataState);
      };

    if (isLoading) {
        return <div className='center-align'><h3>Loading...</h3></div>;
    }

    // Only show User Assignments for Benefits, Authorizations, and Escalated worklist types
    const showUserAssignments = type === 'Benefits' || type === 'AdecBenefits' || type === 'Authorization' || type === 'Authorization Denied' || type === 'Escalated';

    return <React.Fragment>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Typography className="psn-green" variant='h6'>{type === 'CheckOonNotes' ? 'Check OON Notes Worklist' : type + ' Worklist'}</Typography>
            <Button variant='outlined' onClick={()=>navigate(-1)} color='success'><FontAwesomeIcon icon={'arrow-left'}/><span className="ms-1">Go Back</span></Button>
        </Stack>

        {showUserAssignments ? (
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <Card sx={{ flex: 1, padding: '16px', borderRadius: '10px' }}>
                    <Box sx={{ borderBottom: '3px solid gray', paddingBottom: '8px', marginBottom: '16px' }}>
                        <Typography variant="h6" className="psn-green">Payer Summary</Typography>
                    </Box>
                    <Grid
                        key={`${type}-${center}-${filter}`}
                        data={process((data ?? []).map(item => ({ ...item, payer: item.payer ? item.payer : "Missing Payer" })), dataState)}
                        {...dataState}
                        style={{ height: '750px' }}
                        sortable={{mode:'multiple'}}
                        groupable={false}
                        onDataStateChange={dataStateChange}>
                        <Column cell={PayerSummaryViewCell} width={'75px'} groupable={false}/>
                        <Column field="payer" title="Payer Type" width="250px" />
                        <Column field="count" title="Total Cases" width="150px" />
                    </Grid>
                </Card>

                <Box sx={{ flex: 1 }}>
                    <UserAssignmentSummary worklistType={type!} center={center!} filter={filter!} />
                </Box>
            </Box>
        ) : (
            <Grid
                key={`${type}-${center}-${filter}`}
                data={process((data ?? []).map(item => ({ ...item, payer: item.payer ? item.payer : "Missing Payer" })), dataState)}
                {...dataState}
                style={{ height: '750px' }}
                sortable={{mode:'multiple'}}
                groupable={false}
                onDataStateChange={dataStateChange}>
                <Column cell={PayerSummaryViewCell} width={'75px'} groupable={false}/>
                <Column field="payer" title="Payer Type" width="250px" />
                <Column field="count" title="Total Cases" width="150px" />
            </Grid>
        )}
        
    </React.Fragment>
}
export {PayerSummaryWorklist}